var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGcpLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0965 9.17943C18.711 7.80293 17.937 6.59093 16.898 5.66443L14.599 7.96343C15.4375 8.64593 16.003 9.65043 16.106 10.7874V11.5414C16.119 11.5414 16.131 11.5374 16.144 11.5374C17.305 11.5374 18.25 12.4824 18.25 13.6434C18.25 14.8044 17.305 15.7499 16.144 15.7499C16.131 15.7499 16.119 15.7464 16.106 15.7459V15.7499H12.773H12V18.9999H16.106V18.9979C16.119 18.9979 16.131 18.9999 16.144 18.9999C19.0975 18.9999 21.5 16.5969 21.5 13.6439C21.5 11.7814 20.543 10.1394 19.0965 9.17943Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.78796C7.9335 3.78796 4.625 7.09646 4.625 11.163C4.625 11.2795 4.637 11.393 4.6425 11.508H7.8925C7.883 11.394 7.875 11.2795 7.875 11.163C7.875 8.88846 9.7255 7.03796 12 7.03796C12.9845 7.03796 13.889 7.38596 14.599 7.96346L16.898 5.66446C15.594 4.50146 13.8805 3.78796 12 3.78796Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85653 15.7499C7.85603 15.7499 7.85603 15.7499 7.85553 15.7499C7.55003 15.7499 7.26153 15.6814 6.99953 15.5634L4.64453 17.9184C5.54103 18.5939 6.65103 18.9999 7.85553 18.9999C7.85603 18.9999 7.85603 18.9999 7.85653 18.9999H12.0005V15.7499H7.85653Z",
    fill: "#2E7D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13.6452C5.75 12.4852 6.695 11.5402 7.855 11.5402C8.7065 11.5402 9.444 12.0517 9.7755 12.7872L12.134 10.4287C11.1535 9.12766 9.6015 8.29016 7.8545 8.29016C4.905 8.29016 2.5 10.6902 2.5 13.6452C2.5 15.3907 3.3455 16.9402 4.644 17.9187L6.999 15.5637C6.265 15.2347 5.75 14.4997 5.75 13.6452Z",
    fill: "#FFC107"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGcpLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gcp-logo.d95b6826f79dc00038567f92ed6c791c.svg";